import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomToastPage } from './custom-toast.page';
import { modalGuard } from '../../../core/guards/modal/modal.guard';

const routes: Routes = [
  {
    path: '',
    component: CustomToastPage,
    canDeactivate: [modalGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomToastPageRoutingModule {}
